import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentInfoService } from '@interacta-shared/data-access-configuration';
import { TranslatePipe } from '@ngx-translate/core';
import { of, timer } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

@Component({
    imports: [CommonModule, TranslatePipe],
    selector: 'interacta-out-of-service-page',
    templateUrl: './out-of-service-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutOfServicePageComponent implements OnInit {
    private readonly environmentInfoService = inject(EnvironmentInfoService);
    private readonly route = inject(ActivatedRoute);
    private readonly destroyRef = inject(DestroyRef);

    pollingServerBack(): void {
        // Polling check environment
        timer(20000, 20000)
            .pipe(
                switchMap(() =>
                    this.environmentInfoService.getCurrentEnvironment().pipe(
                        map(() => true),
                        catchError(() => of(false)),
                        filter((health) => !!health),
                        takeUntilDestroyed(this.destroyRef),
                    ),
                ),
            )
            .subscribe((_) => {
                window.location.reload();
            });
    }

    ngOnInit(): void {
        this.route.queryParams
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.pollingServerBack());
    }
}
